import React from "react"
import ApolloClient from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { ApolloProvider } from "react-apollo"
import { split } from "apollo-link"
import { setContext } from "apollo-link-context"
import { createUploadLink } from "apollo-upload-client"
import { WebSocketLink } from "apollo-link-ws"
import { onError } from "apollo-link-error"
import { getMainDefinition } from "apollo-utilities"
import { ToastContainer, Flip, toast } from "react-toastify"
import { persistCache } from "apollo-cache-persist"
import { uri, webSocketUri } from "./utils"
import { BreadcrumbProvider } from "./components/breadcrumb"
import defaultData from "./defaultData"

const token = () => localStorage.getItem("token")

const httpLink = createUploadLink({ uri })

// Create a WebSocket link:
const wsLink = new WebSocketLink({
  uri: webSocketUri,
  options: {
    reconnect: true,
    connectionParams: () => {
      return {
        headers: { "x-token": token() }
      }
    }
  }
})

const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them

  return {
    headers: {
      ...headers,
      "x-token": token()
    }
  }
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const configuration = { autoClose: 5000 }
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      console.log(error)

      if (error?.extensions.code === "BAD_USER_INPUT") {
        toast.error("😣 檔案匯入資料庫時失敗")
        return
      }

      if (error?.extensions.code === "UNAUTHENTICATED") {
        localStorage.setItem("token", "")
        toast.error(
          error.message || "😣 權限過期或帳號密碼錯誤，請重新登入",
          configuration
        )
        if (!error.message) {
          setTimeout(() => {
            document.location.reload()
          }, configuration.autoClose)
        }
      } else {
        toast.error(`😣 ${error.message}`, configuration)
      }
    })
  } else if (networkError) {
    toast.error("網路連線異常，請稍後再試", configuration)
  }
})

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    )
  },
  wsLink,
  httpLink
)

const cache = new InMemoryCache({
  dataIdFromObject: (object) => object.id || null
})

persistCache({
  cache,
  storage: window.localStorage
})

// const persistor = new CachePersistor({
//   cache,
//   storage: window.localStorage
// })
// persistor.purge()

const client = new ApolloClient({
  link: authLink.concat(errorLink.concat(link)),
  cache,
  resolvers: {}
})

cache.writeData({
  data: defaultData
})

const App = ({ children }) => {
  return (
    <>
      <ApolloProvider client={client}>
        <BreadcrumbProvider>{children}</BreadcrumbProvider>
      </ApolloProvider>
      <ToastContainer transition={Flip} autoClose={10000} />
    </>
  )
}

export default App
